export interface ILogEntry {
	id: number;
	action: Action;
	accountId: number;
	object: number;
	objectType: ObjectType ;
	time: number;
	scheduleTag: number[];
  }

export enum Action {
    UNKNOWN ="UNKNOWN",
    FAMILY_CREATED = "FAMILY_CREATED", 
    FAMILY_MEMBER_CREATE = "FAMILY_MEMBER_CREATE", 
    FAMILY_MEMBER_MODIFY = "FAMILY_MEMBER_MODIFY", 
    FAMILY_MEMBER_DELETE = "FAMILY_MEMBER_DELETE",
    FAMILY_MEMBER_INVITE = "FAMILY_MEMBER_INVITE", 
    CHILD_INFO_UPDATE = "CHILD_INFO_UPDATE", 
    SCHEDULE_SHARE = "SCHEDULE_SHARE", 
    SUGGESTION_CREATED = "SUGGESTION_CREATED", 
    SUGGESTION_ACCEPTED = "SUGGESTION_ACCEPTED", 
    SUGGESTION_REJECTED = "SUGGESTION_REJECTED", 
    SCHOOLDAYS_SCHEDULE_UPDATED = "SCHOOLDAYS_SCHEDULE_UPDATED", 
    SCHOOLDAY_VAB_UPDATED = "SCHOOLDAY_VAB_UPDATED", 
    SCHOOLDAY_VABDAY_REMOVED = "SCHOOLDAY_VABDAY_REMOVED",
    HOLIDAYS_SCHEDULE_UPDATED = "HOLIDAYS_SCHEDULE_UPDATED",
    AGREEMENT_SUGGESTED = "AGREEMENT_SUGGESTED", 
    AGREEMENT_RESPONDED = "AGREEMENT_RESPONDED",
    EVENT_CREATED = "EVENT_CREATED", 
    EVENT_GROUP_CREATED = "EVENT_GROUP_CREATED", 
    EVENT_MODIFIED = "EVENT_MODIFIED", 
    EVENT_GROUP_MODIFIED = "EVENT_GROUP_MODIFIED", 
    EVENT_DELETED = "EVENT_DELETED", 
    EVENT_GROUP_DELETED = "EVENT_GROUP_DELETED",
    TODO_CREATED = "TODO_CREATED", 
    TODO_MODIFIED = "TODO_MODIFIED", 
    TODO_DELETED = "TODO_DELETED",
    FLOW_POST_CREATED = "FLOW_POST_CREATED",
    ECO_PURCHASE_CREATED = "ECO_PURCHASE_CREATED",
    ECO_PURCHASE_CHANGE = "ECO_PURCHASE_CHANGE",
    ECO_TRANSFER_CREATED = "ECO_TRANSFER_CREATED",
    SHARED_NOTE_CREATED = "SHARED_NOTE_CREATED",
    SHARED_NOTE_MODIFIED = "SHARED_NOTE_MODIFIED",

  }
  
  export enum ObjectType {
    UNKNOWN="UNKNOWN", 
    FAMILY_MEMBER = "FAMILY_MEMBER", 
    CHANGE_REQUEST = "CHANGE_REQUEST", 
    SCHEDULE = "SCHEDULE", 
    SCHOOLDAY = "SCHOOLDAY", 
    FAMILY = "FAMILY", 
    AGREEMENT = "AGREEMENT",
    EVENT = "EVENT", 
    EVENT_GROUP = "EVENT_GROUP", 
    TODO = "TODO",
    FLOW_POST = "FLOWPOST",
    ECO = "ECO",
    NOTES = "NOTES",
  }


// WEBPACK FOOTER //
// ./src/app-types/websocket/log.types.ts